const routeGames = () => '/games';

export default routeGames;